import { css } from "@styled-system/css";

/**
 * Shared look for every toggle button on the overview page (filter chips,
 * Strip/Grid segments). Four states, all from okshaun tokens:
 *   rest     → subtle text, plain border
 *   hover    → surface.hovered fill, border.bold
 *   pressed  → surface.pressed fill
 *   on       → bg.selected fill, text.selected, border.selected (aria-pressed)
 * Keyboard focus draws the border.focused ring.
 */
export const pressableRaw = css.raw({
  fontFamily: "mono",
  fontSize: "12",
  lineHeight: "tight",
  color: "text.subtle",
  bg: "transparent",
  border: "default",
  cursor: "pointer",
  transitionProperty: "[color, background-color, border-color, box-shadow]",
  transitionDuration: "fast",
  transitionTimingFunction: "out",
  outline: "none",
  _hover: { color: "text", bg: "surface.hovered", borderColor: "border.bold" },
  _active: { bg: "surface.pressed" },
  _focusVisible: { boxShadow: "[0 0 0 2px var(--oks-colors-border-focused)]" },
  "&[aria-pressed=true]": {
    color: "text.selected",
    bg: "bg.selected",
    borderColor: "border.selected",
  },
  "&[aria-pressed=true]:hover": { bg: "bg.selected.hovered" },
  "&[aria-pressed=true]:active": { bg: "bg.selected.pressed" },
});

export const pressable = css(pressableRaw);

/** Pill shape for filter chips. Compose with css(pressableRaw, chipShapeRaw, …). */
export const chipShapeRaw = css.raw({ px: "12", py: "5", borderRadius: "999" });

/** Compact rounded segment for the Strip/Grid control. */
export const segmentShapeRaw = css.raw({ px: "10", py: "3", borderRadius: "4" });
